import type { FC } from 'react';
import React from 'react';

import iconSrc from '@wwe-portal/ui/assets/images/subscription/add_club_coin_icon.png';

export type AddClubCurrencyIconProps =
  React.ReactComponentElement<'img'>['props'];
export const AddClubCurrencyIcon: FC<AddClubCurrencyIconProps> = (props) => {
  return <img alt="Add Club Coin" src={iconSrc} {...props} />;
};
